import { FEATURE_FLAGS } from '../../../../featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from 'dashboard/helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import CustomRolesHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-roles'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'custom_roles_list',
          meta: {
            ...(window.globalConfig?.HYTEC_ROLES_ENABLED
              ? { featureFlag: FEATURE_FLAGS.HYTEC_CUSTOM_ROLES }
              : {
                  featureFlag: FEATURE_FLAGS.CUSTOM_ROLES,
                  installationTypes: [
                    INSTALLATION_TYPES.CLOUD,
                    INSTALLATION_TYPES.ENTERPRISE,
                  ],
                }),
            permissions: ['administrator'],
          },
          component: CustomRolesHome,
        },
      ],
    },
  ],
};
